var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1151,
    height: 1152,
    viewBox: "0 0 1151 1152",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    fill: "#006fcf",
    stroke: "none",
    d: "M -0 1152 L 1151.997314 1152 L 1151.997314 0 L -0 0 Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "#ffffff",
    stroke: "none",
    d: "M 417.315582 969.713989 L 872.827576 970.680664 L 944.366211 890.869995 L 1016.41687 970.379333 L 1151.996826 970.379333 L 1151.996826 853.936646 L 1067.080933 762.360718 L 1151.996826 671.615356 L 1151.996826 557.593994 L 417.315582 556.934021 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "#006fcf",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 466.388916 924.460022 L 466.388916 602.360046 L 739.49823 602.360046 L 739.49823 676.559998 L 554.812927 676.559998 L 554.812927 726.926697 L 735.094238 726.926697 L 735.094238 799.895996 L 554.812927 799.895996 L 554.812927 849.368042 L 739.49823 849.368042 L 739.49823 924.458679 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "#006fcf",
    stroke: "none",
    d: "M 1040.054321 602.364014 L 947.44635 704.454712 L 855.103699 602.364014 L 738.131714 602.364014 L 889.255737 763.226685 L 738.134399 924.460022 L 851.925049 924.460022 L 944.943726 821.34668 L 1038.926392 924.460022 L 1151.99707 924.460022 L 1151.99707 919.886658 L 1004.093018 763.226685 L 1151.99707 604.901367 L 1151.99707 602.364014 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path28",
    fill: "#ffffff",
    stroke: "none",
    d: "M 985.047546 190.554016 L 947.216919 296.375366 L 909.514221 190.554016 L 690.88092 190.554016 L 690.88092 331.794006 L 628.67688 190.554016 L 451.580902 190.554016 L 269.695618 603.335327 L 1151.996948 603.335327 L 1151.996948 190.554016 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    fill: "#006fcf",
    fillRule: "evenodd",
    stroke: "none",
    d: "M 497.394928 420.55603 L 540.254944 318.106689 L 583.085571 420.55603 Z M 485.112244 235.400024 L 342.196259 557.226685 L 440.220245 557.226685 L 467.180267 492.783997 L 613.280273 492.783997 L 640.2229 557.226685 L 740.682922 557.226685 L 598.358948 235.400024 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    fill: "#006fcf",
    stroke: "none",
    d: "M 739.342773 557.171997 L 826.005432 557.17334 L 826.005432 336.110657 L 908.224121 557.17334 L 986.114746 557.17334 L 1066.66272 336.861328 L 1066.66272 557.924011 L 1151.996094 557.17334 L 1151.996094 235.348022 L 1019.385437 235.348022 L 948.026794 433.67334 L 877.132141 235.822693 L 739.342773 235.34668 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.eaa92970e1a4a3d32b770650a14f1c1a.svg";
export { ForwardRef as ReactComponent };